import {
    GlobalSearchInput,
    GlobalSearchOutput,
    SectionType,
} from '@/app/models/search'
import { GlobalSearchService } from '@/app/services/GlobalSearchService'
import { layoutActions } from '@Techedge/digitalportal-shared'

import { NavbarAppState } from '../states/appState'
import { GlobalSearchState } from '../reducers/global-search'

export const GlobalSearchAction = {
    GET_SEARCH_ERROR: 'GET_SEARCH_ERROR',
    GET_SEARCH_SUCCESS: 'GET_SEARCH_SUCCESS',
    GET_SEARCH_REQUEST: 'GET_SEARCH_REQUEST',
}

export const getGlobalSearchSuccess = (value: GlobalSearchOutput) => {
    return { type: GlobalSearchAction.GET_SEARCH_SUCCESS, value }
}

export const getGlobalSearchError = (value: any) => {
    return { type: GlobalSearchAction.GET_SEARCH_ERROR, value }
}

export const getGlobalSearchRequest = (value: GlobalSearchInput) => {
    return { type: GlobalSearchAction.GET_SEARCH_REQUEST, value }
}

export const resetSearchInput = (resetOutput?: boolean) => {
    return (dispatch: any, getState: () => NavbarAppState) => {
        let state: GlobalSearchState = getState().globalSearchReducer
        dispatch(getGlobalSearchRequest({ search: '' }))
        if (resetOutput) {
            dispatch(resetSearchOutput())
        } else {
            dispatch(getGlobalSearchSuccess(state.searchOutput))
        }
    }
}

export const resetSearchOutput = () => {
    return (dispatch: any) => {
        dispatch(getGlobalSearchSuccess({}))
    }
}

export const resetSearch = () => {
    return (dispatch: any) => {
        dispatch(resetSearchInput(true))
    }
}

export const closeGlobalSearch = () => {
    return (dispatch: any) => {
        dispatch(resetSearch())
        // dispatch(layoutActions.setModals({ type: null }))
    }
}

export const getGlobalSearch = (params: GlobalSearchInput | any) => {
    return (dispatch: any) => {
        dispatch(getGlobalSearchRequest(params))
        GlobalSearchService.getGlobalSearch(params)
            .then((result: any) => {
                // Object.keys(SectionType).map((key: string) => {
                //     GlobalSearchService.searchOutputTemplate[key] = []
                //     for (let i = 0; i <= 40; i++) {
                //         let randomName = 'Project '
                //         for (let i = 0; i < 8; i++) {
                //             const random = Math.floor(Math.random() * 27)
                //             randomName += String.fromCharCode(97 + random)
                //         }
                //         let item: any = {}
                //         item.title = randomName
                //         if (key === SectionType.activity || key === SectionType.calendar) {
                //             item.projectId = 'asdasdsadasdas'
                //             item.storeIdsList = [3026]
                //         }

                //         GlobalSearchService.searchOutputTemplate[key].push(item)
                //     }
                // })

                if (result?.data) {
                    dispatch(getGlobalSearchSuccess(result.data))
                } else {
                    dispatch(
                        getGlobalSearchError(
                            new Error(
                                'unexptected error while executing the search operation'
                            )
                        )
                    )
                }
            })
            .catch((error: any) => {
                dispatch(getGlobalSearchError(error))
            })
    }
}
